import * as React from 'react'
import { SideDrawer } from '@sales-center/components'
import { CTMWebformSideDrawerContents } from './CTMWebformSideDrawerContents/CTMWebformSideDrawerContents'
import { Scrollbar } from '@workwave-tidal/core/components'
import Stack from '@mui/material/Stack'
import { WebformSideDrawerContents } from './WebformSideDrawerContents/WebformSideDrawerContents'
import { Theme } from '@mui/material/styles'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { timeFormat } from '@sales-center/common'

type Props = {
  hideInfoBox?: boolean
  onClose: () => void
  open: boolean
  webFormCallTrackingEventId?: string | null
  draftLeadId: number | null
  type: string
  submittedBy?: string
  createdTime?: Date | string
}

export function WebFormSideDrawer(props: Props) {
  const { onClose, open, webFormCallTrackingEventId, createdTime } = props

  const { formatDate } = useLocalizationDateFormat()

  const dateSubmittedFormat = React.useMemo(
    () => formatDate(createdTime) + ' ' + timeFormat(createdTime || ''),
    [createdTime, formatDate],
  )

  return (
    <>
      <SideDrawer
        title="Pending Lead Details"
        open={open}
        onClose={onClose}
        width={320}
        overflow={'hidden'}
      >
        <Stack sx={{ height: '93svh' }}>
          <Scrollbar testId="scrollbar">
            <Stack
              direction="column"
              sx={{
                flexGrow: 1,
                padding: (theme: Theme) => theme.spacing(2),
                paddingBottom: 10,
              }}
            >
              {webFormCallTrackingEventId ? (
                <CTMWebformSideDrawerContents
                  {...props}
                  dateSubmittedFormat={dateSubmittedFormat.trim()}
                />
              ) : (
                <WebformSideDrawerContents
                  {...props}
                  dateSubmittedFormat={dateSubmittedFormat.trim()}
                />
              )}
            </Stack>
          </Scrollbar>
        </Stack>
      </SideDrawer>
    </>
  )
}
